import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	table: {
		borderRadius: '12px',
		border: '1px solid',
		borderColor: 'divider',
		overflow: 'hidden',
		'.lightTheme &': {
			backgroundColor: '#fff',
		},
		'.darkTheme &': {
			backgroundColor: 'rgba(255, 255, 255, 0.04)',
		},
	},
	row: {
		display: 'grid',
		gridTemplateColumns: '32px minmax(0, 1fr) 110px 70px',
		alignItems: 'center',
		gap: '8px',
		padding: '7px 12px',
		borderBottom: '1px solid',
		borderColor: 'divider',
		cursor: 'pointer',
		fontSize: '13px',
		'&:last-of-type': {
			borderBottom: 'none',
		},
		'&:hover': {
			backgroundColor: 'var(--account-accent-soft, rgba(12, 109, 223, 0.08))',
		},
		'&.active': {
			backgroundColor: 'var(--account-accent-soft, rgba(12, 109, 223, 0.12))',
			boxShadow: 'inset 3px 0 0 var(--account-accent, #0C6DDF)',
		},
		'&.empty': {
			color: 'text.disabled',
		},
	},
	head: {
		fontSize: '11px',
		fontWeight: 700,
		textTransform: 'uppercase',
		letterSpacing: '0.04em',
		color: 'text.secondary',
		cursor: 'default',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	index: {
		color: 'text.secondary',
		fontSize: '12px',
	},
	stops: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	time: {
		color: 'text.secondary',
		fontSize: '12px',
	},
	count: {
		textAlign: 'right',
		fontWeight: 700,
	},
} as const satisfies SxType
